import { render, staticRenderFns } from "./rt2.vue?vue&type=template&id=21fc7bd1&scoped=true&"
import script from "./rt2.vue?vue&type=script&lang=js&"
export * from "./rt2.vue?vue&type=script&lang=js&"
import style0 from "./rt2.vue?vue&type=style&index=0&id=21fc7bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc7bd1",
  null
  
)

export default component.exports